import Experiment from '@mc/experiments-react'

import { OutcomeTiles } from './components/OutcomeTiles'
import { CM_OUTCOMES_EXP_FLAG } from './constants'

interface OutcomeTilesExpProps {
  children?: React.ReactNode
}

export const OutcomeTilesExp = ({ children }: OutcomeTilesExpProps) => (
  <Experiment
    name={CM_OUTCOMES_EXP_FLAG}
    variant_1={() => <OutcomeTiles control={children} />}
    default={() => children}
  />
)
